// Display rules for a user's MFA status from /realm/mfa-status.
// 'unknown' means the identity server did not answer for that user. It must
// never be shown (or acted on) as "not enforced".
export const MFA_STATUS_UNKNOWN = 'unknown';

const CHIPS = {
  configured: { label: 'Configured', backgroundColor: '#F0F9F4', color: '#27AE60', borderColor: '#27AE6020' },
  enforced: { label: 'Pending Setup', backgroundColor: '#FEF9E7', color: '#F39C12', borderColor: '#F39C1220' },
  [MFA_STATUS_UNKNOWN]: { label: 'Unknown', backgroundColor: '#EEF1F5', color: '#5D6D7E', borderColor: '#5D6D7E33' },
  none: { label: 'Not Enforced', backgroundColor: '#F5F5F5', color: '#999999', borderColor: '#E5E5E5' },
};

export const mfaStatusChip = (status) => CHIPS[status] || CHIPS.none;
